import { useCallback, useEffect, useState } from "react";
import { Check, X, FileText, QrCode, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const openDoc = async (uid) => {
  try {
    const { data } = await api.get(`/admin/verifications/${uid}/document`, { responseType: "blob" });
    window.open(URL.createObjectURL(data), "_blank");
  } catch (e) { toast.error(errMsg(e)); }
};

const QrInfo = ({ v }) => (
  <div className="text-xs space-y-1">
    <div className={`flex items-center gap-1 font-bold ${v.qr_match ? "text-emerald-700" : "text-red-600"}`}>
      <QrCode size={14} />{v.qr_match ? "الباركود مطابق لرقم السجل" : v.qr_found ? "الباركود غير مطابق" : "لم يُقرأ باركود"}
      {v.qr_found && <span className={v.qr_official ? "text-emerald-700" : "text-amber-700"}>· {v.qr_official ? "رابط جهة رسمية" : "رابط غير رسمي"}</span>}
    </div>
    {v.qr_data?.map((d) => (d.startsWith("https://")
      ? <a key={d} href={d} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-brand break-all" dir="ltr"><ExternalLink size={12} />{d}</a>
      : <div key={d} className="text-slate-500 break-all" dir="ltr">{d}</div>))}
  </div>
);

export const AdminVerifications = ({ onCount }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get("/admin/verifications").then((r) => { setItems(r.data); onCount?.(r.data.length); }), [onCount]);
  useEffect(() => { load(); }, [load]);
  const act = async (uid, status) => {
    const note = status === "rejected" ? window.prompt("سبب الرفض (اختياري)") || "" : "";
    try { await api.post(`/admin/verifications/${uid}/status`, { status, note }); toast.success(status === "verified" ? "تم توثيق الحساب" : "تم الرفض"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!items.length) return <div className="text-center py-12 text-slate-500 bg-white border rounded-xl">لا توجد طلبات توثيق معلقة.</div>;
  return (
    <div className="space-y-3">
      {items.map((u) => (
        <div key={u.user_id} className="bg-white border rounded-xl p-4 flex flex-wrap gap-4 items-start justify-between" data-testid={`pending-verification-${u.user_id}`}>
          <div className="space-y-1 min-w-0">
            <div className="font-bold">{u.verification.full_name} {u.role && <span className="text-[11px] font-semibold bg-slate-100 text-slate-700 rounded-md px-1.5 py-0.5 mx-1" data-testid={`verification-role-${u.user_id}`}>{u.role === "seller" ? "بائع" : "مشتري"}</span>}<span className="text-xs text-slate-500 font-normal">({u.email})</span></div>
            <div className="text-sm">سجل تجاري: <b dir="ltr">{u.verification.cr_number}</b> · هوية: <b dir="ltr">{u.verification.national_id}</b></div>
            <QrInfo v={u.verification} />
            <button onClick={() => openDoc(u.user_id)} data-testid={`view-doc-${u.user_id}`} className="text-xs font-bold text-brand flex items-center gap-1"><FileText size={14} />عرض السجل المرفوع</button>
          </div>
          <div className="flex gap-2">
            <button data-testid={`verify-approve-${u.user_id}`} onClick={() => act(u.user_id, "verified")} className="flex items-center gap-1 bg-emerald-600 text-white rounded-lg px-4 py-2 text-xs font-bold"><Check size={14} />توثيق</button>
            <button data-testid={`verify-reject-${u.user_id}`} onClick={() => act(u.user_id, "rejected")} className="flex items-center gap-1 bg-red-50 text-red-700 rounded-lg px-4 py-2 text-xs font-bold"><X size={14} />رفض</button>
          </div>
        </div>
      ))}
    </div>
  );
};
